import React from 'react';
import { useFormContext } from 'react-hook-form';
import { TouchableOpacity } from 'react-native';
import { HelperText } from 'react-native-paper';
import { Trans } from '@lingui/macro';

import useMediaPicker, { PickedMedia } from '@src/hooks/useMediaPicker';
import { Source } from '@src/types';

import { AvatarContainer, AvatarEditText, AvatarImage } from './styled';

type Props = {
  name: string;
  source?: Source;
  compact?: boolean;
  onImagePicked?: (image: PickedMedia) => void;
};

const Component: React.FC<Props> = (props) => {
  const { name, compact, source, onImagePicked } = props;
  const { register, unregister, errors, setValue, watch } = useFormContext();
  const { media, pickMedia } = useMediaPicker('image', 'profile');
  const defaultValue = source?.uri;
  const error = errors?.[name];
  const uri = watch(name, defaultValue);

  React.useEffect(() => {
    if (defaultValue) {
      setValue(name, defaultValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue]);

  React.useEffect(() => {
    register(name);
    return () => unregister(name);
  }, [name, register, unregister]);

  const avatarSource = { uri } || require('@src/assets/images/avatar.png');

  const avatarImageHandler = async () => {
    pickMedia()
      .then((res) => {
        res && onImagePicked && onImagePicked(res);
      })
      .catch(console.log);
  };

  return (
    <>
      <TouchableOpacity onPress={avatarImageHandler}>
        <AvatarContainer>
          {media && !media?.cancelled ? (
            <AvatarImage source={{ uri: media.uri }} />
          ) : (
            <AvatarImage source={avatarSource} />
          )}
          <AvatarEditText>
            <Trans>Tap to Edit</Trans>
          </AvatarEditText>
        </AvatarContainer>
      </TouchableOpacity>
      {!compact && (
        <HelperText type="error" visible={!!error}>
          {error?.message}
        </HelperText>
      )}
    </>
  );
};

export default Component;
